import * as React from "react";
import classnames from "classnames";
/* empty css                       */
const ProductBlockOuter = React.forwardRef(
  ({ className, tealiumAttributes, children }, ref) => {
    return /* @__PURE__ */ React.createElement(
      "article",
      {
        ref,
        className: classnames("product-block-outer", className),
        ...tealiumAttributes
      },
      children
    );
  }
);
export {
  ProductBlockOuter
};
//# sourceMappingURL=ProductBlockOuter.js.map
